import * as React from 'react';
import { GroupLineItemUI, LineItemUI } from './LineItemUI';
import { formatFees } from '../../utils/formatUtils';
import { unescape } from 'lodash';

export interface ICashSummaryUIProps {
    isSinglePrice: boolean;
    tradeValue: number;
    tradeInWithSign: string;
    vehicleCondition: string;
    advertisedPriceLabel?: string;
    cashOffer?: number;
    dealerFees?: IDealerFee[];
    dealerFeesTotal?: number;
    initialOfferPrice?: number;
    offerPrice?: number;
    totalTax?: number;
    dmvFees?: number;
    retailPrice?: number;
    notAvailableText?: string;
    special?: string;
}

export interface IDealerFee {
    dealerFeeDesc?: string;
    dealerFeeAmount?: number;
}

export interface ICashSummaryState {}

export default class CashSummaryUI extends React.Component<ICashSummaryUIProps, ICashSummaryState> {
    constructor(props: ICashSummaryUIProps) {
        super(props);
    }

    getTradeInLineItem = () => {
        const { tradeInWithSign, tradeValue } = this.props;
        return tradeValue && tradeValue > 0 ? (
            <LineItemUI key="4" label="Net Trade-in Value" value={tradeInWithSign} notAvailableText="" id="tradeAllowance" />
        ) : null;
    };

    getAdvertisedPriceLineItem = () => {
        const { retailPrice, vehicleCondition, isSinglePrice } = this.props;
        let priceLabel;

        if (vehicleCondition === 'New') {
            priceLabel = 'MSRP';
        }
        if (vehicleCondition !== 'New' && !isSinglePrice) {
            priceLabel = 'Advertised Price';
        }
        return priceLabel ? (
            <div>
                <LineItemUI key="0" label={priceLabel} value={formatFees(retailPrice)} notAvailableText="" id="msrp" />
                <hr key="1" />
            </div>
        ) : null;
    };

    getDealerFeeLineItems = () => {
        const { dealerFees } = this.props;

        if (!dealerFees || dealerFees.length <= 0) {
            return null;
        }

        return dealerFees.map((fee, i) => {
            return (
                <LineItemUI
                    key={7 + i}
                    label={fee.dealerFeeDesc.replace('&amp;', '&')}
                    value={formatFees(fee.dealerFeeAmount)}
                    notAvailableText="Not Included"
                    id={`dealerFee_${i}`}
                />
            );
        });
    };

    getSpecialsLineItem = () => {
        const { special } = this.props;
        if (special) {
            return (<LineItemUI
                key="3"
                label="Specials"
                value={special}
                id="incentivesAmount"
            />);
        }
        return null;
    }

    render() {
        const { isSinglePrice, cashOffer, offerPrice, dmvFees, totalTax } = this.props;
        const priceLabel = isSinglePrice ? 'My Price' : 'My Asking Price';

        return (
            <div className="dr-ui-summary-container">
                <div className="summary-column">
                    {this.getAdvertisedPriceLineItem()}

                    <LineItemUI key="2" label={priceLabel} value={formatFees(offerPrice)} notAvailableText="" id="offerPrice" />

                    {this.getSpecialsLineItem()}

                    {this.getTradeInLineItem()}

                    <LineItemUI
                        key="5"
                        label="Taxes"
                        value={formatFees(totalTax) || null}
                        notAvailableText="Not Included"
                        id="taxes"
                    />

                    <LineItemUI
                        key="6"
                        label="DMV Fees"
                        value={formatFees(dmvFees) || null}
                        notAvailableText="Not Included"
                        id="dmvFees"
                    />

                    {this.getDealerFeeLineItems()}

                    <hr key="20" />

                    <GroupLineItemUI
                        label="Est. Cash Payment"
                        value={formatFees(cashOffer)}
                        notAvailableText="Not Available"
                        id="totalCash"
                    />
                </div>
            </div>
        );
    }
}
